//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const TOOLTIP_ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right'
};
const FIRST_STEP = 0;
const defaultConfig = {
  steps: [],
  initialStep: FIRST_STEP,
  backdropClickToClose: true,
  tooltipAlign: TOOLTIP_ALIGN.center,
  titleClass: '',
  titleStyle: {},
  messageClass: '',
  messageStyle: {},
  skipButtonText: 'Skip',
  skipButtonClass: '',
  skipButtonStyle: {},
  prevButtonText: 'Prev',
  prevButtonClass: '',
  prevButtonStyle: {},
  nextButtonText: 'Next',
  nextButtonClass: '',
  nextButtonStyle: {},
  tooltipBgColor: '',
  tooltipRadius: '',
  tooltipPadding: '',
  tooltipShadow: '',
  stepBackdropColor: '',
  stepBackdropRadius: '',
  stepBackdropShadow: ''
};
var script = {
  name: 'Guide',
  props: {
    config: {
      type: Object,
      default: () => defaultConfig
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: vm => ({
    innerConfig: { ...defaultConfig,
      ...vm.config
    },
    step: vm.config.initialStep || defaultConfig.initialStep,
    tooltip: {},
    currentStepData: {
      message: ''
    },
    observeFlag: false,
    innerValue: vm.value,
    isBeginning: false,
    isEnd: false
  }),

  mounted() {
    if (this.value) {
      this.init();
    }
  },

  computed: {
    canPrev() {
      return !(this.isBeginning || this.reachBeginning);
    },

    canNext() {
      return !(this.isEnd || this.reachEnd);
    },

    reachBeginning() {
      return !this.isBeginning && this.step === FIRST_STEP;
    },

    reachEnd() {
      return !this.isEnd && this.step >= this.stepsCount;
    },

    stepsCount() {
      return this.innerConfig.steps.length - 1;
    },

    noSteps() {
      return this.stepsCount <= 0;
    },

    tooltipStyle() {
      return { ...(this.innerConfig.tooltipBgColor ? {
          'background-color': this.innerConfig.tooltipBgColor,
          'border-color': this.innerConfig.tooltipBgColor
        } : {}),
        ...(this.innerConfig.tooltipRadius ? {
          'border-radius': this.innerConfig.tooltipRadius
        } : {}),
        ...(this.innerConfig.tooltipPadding ? {
          padding: this.innerConfig.tooltipPadding
        } : {}),
        ...(this.innerConfig.tooltipShadow ? {
          'box-shadow': this.innerConfig.tooltipShadow
        } : {})
      };
    },

    stepBackdropStyle() {
      return { ...(this.innerConfig.stepBackdropColor ? {
          'background-color': this.innerConfig.stepBackdropColor
        } : {}),
        ...(this.innerConfig.stepBackdropRadius ? {
          'border-radius': this.innerConfig.stepBackdropRadius
        } : {}),
        ...(this.innerConfig.stepBackdropShadow ? {
          'box-shadow': this.innerConfig.stepBackdropShadow
        } : {})
      };
    }

  },
  watch: {
    step(step) {
      this.toStep(step);
    },

    value(value) {
      if (this.noSteps) {
        return;
      }

      if (value && !this.innerValue) {
        this.init();
      }

      this.innerValue = value;
    },

    reachBeginning(begin) {
      if (begin) {
        this.$emit('reachBeginning');
      }
    },

    reachEnd(end) {
      if (end) {
        this.$emit('reachEnd');
      }
    }

  },
  methods: {
    init() {
      if (typeof window === 'undefined') {
        return;
      }

      if (!this.stepsCount) {
        return;
      }

      this.innerValue = true;
      this.$nextTick(() => {
        this.step = this.innerConfig.initialStep;
        this.correctConfigRelativeToDomSteps();
        this.toStep(this.innerConfig.initialStep, false);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting && this.observeFlag) {
              this.$refs.tooltip.scrollIntoView();
              this.observeFlag = false;
            }
          });
        });
        this.observer.observe(this.$refs.tooltip);

        if (this.innerConfig.initialStep === FIRST_STEP) {
          this.isBeginning = true;
          this.$emit('isBeginning');
        } else if (this.innerConfig.initialStep >= this.stepsCount) {
          this.isEnd = true;
          this.$emit('isEnd');
        }

        this.$emit('shown');
      });
    },

    onPrevStep() {
      if (this.step > FIRST_STEP) {
        this.$emit('prevStep', this.step);
        this.step--;
      }
    },

    onNextStep() {
      if (this.step < this.stepsCount) {
        this.$emit('nextStep', this.step);
        this.step++;
      }
    },

    toStep(stepNumber, needObserve = true) {
      if (!this.innerConfig.steps[stepNumber] || !this.innerConfig.steps[stepNumber].el || typeof window === 'undefined') {
        return;
      }

      this.observeFlag = needObserve;
      this.currentStepData = this.innerConfig.steps[stepNumber] || {};
      this.resetStepsStyle();
      this.applyStyles(this.innerConfig.steps[stepNumber].el, {
        zIndex: '999999',
        position: 'relative'
      });
      const stepCoords = this.getStepCoords(stepNumber);
      const guideCords = this.$refs.guide.getBoundingClientRect();
      this.setStepBackdropPosition(stepCoords.top - guideCords.top, guideCords.right - stepCoords.right, guideCords.bottom - stepCoords.bottom, stepCoords.left - guideCords.left);
      this.isBeginning = false;
      this.isEnd = false;
      this.$emit('stepChanged', stepNumber);
    },

    setStepBackdropPosition(top, right, bottom, left) {
      this.applyStyles(this.$refs.tooltip, {
        top: `${top}px`,
        right: `${right}px`,
        bottom: `${bottom}px`,
        left: `${left}px`
      });
      this.correctTooltipPosition();
    },

    correctTooltipPosition() {
      const guideCords = this.$refs.guide.getBoundingClientRect();
      const tooltip = this.$refs.guideControl;
      const tooltipCords = tooltip.getBoundingClientRect();
      this.applyStyles(tooltip, null);
      this.applyStyles(tooltip, this.tooltipStyle);
      this.setTooltipArrowPosition(this.innerConfig.tooltipAlign);
      const rightOffset = tooltipCords.right - guideCords.right;

      if (rightOffset > 0) {
        this.applyStyles(tooltip, {
          transform: 'unset',
          right: 0,
          left: 'unset'
        });

        if (this.innerConfig.tooltipAlign !== TOOLTIP_ALIGN.right) {
          this.setTooltipArrowPosition(TOOLTIP_ALIGN.right);
        }
      }

      const leftOffset = guideCords.left - tooltipCords.left;

      if (leftOffset > 0) {
        this.applyStyles(tooltip, {
          transform: 'unset',
          left: 0
        });

        if (this.innerConfig.tooltipAlign !== TOOLTIP_ALIGN.left) {
          this.setTooltipArrowPosition(TOOLTIP_ALIGN.left);
        }
      }
    },

    setTooltipArrowPosition(align) {
      this.$refs.guideControl.classList.remove('guide__tooltip--arrow-left');
      this.$refs.guideControl.classList.remove('guide__tooltip--arrow-center');
      this.$refs.guideControl.classList.remove('guide__tooltip--arrow-right');
      this.$refs.guideControl.classList.add(`guide__tooltip--arrow-${align}`);
    },

    applyStyles(selector, styles) {
      if (!styles) {
        selector.style = {};
        return;
      }

      for (let [prop, value] of Object.entries(styles)) {
        selector.style[prop] = value;
      }
    },

    onBackdropClick() {
      if (!this.innerConfig.backdropClickToClose) {
        return;
      }

      this.close();
    },

    close() {
      this.$emit('beforeClose');
      this.destroyObserver();
      this.innerValue = false;
      this.$emit('input', this.innerValue);
      this.$emit('close');
    },

    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },

    correctConfigRelativeToDomSteps() {
      this.innerConfig.steps = this.innerConfig.steps.reduce((steps, step) => {
        const domStep = this.$refs.guide.querySelector(step.selector);

        if (domStep) {
          this.$set(step, 'el', domStep);
          steps.push(step);
        }

        return steps;
      }, []);
    },

    getStepCoords(stepNumber) {
      return this.innerConfig.steps[stepNumber].el.getBoundingClientRect();
    },

    resetStepsStyle() {
      this.innerConfig.steps.forEach(step => step.el.style = {});
    }

  },

  beforeDestroy() {
    this.destroyObserver();
  }

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "guide",
    staticClass: "guide"
  }, [_vm.innerValue ? _c('div', {
    staticClass: "guide__backdrop",
    on: {
      "click": _vm.onBackdropClick
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._t("default")], 2), _vm._v(" "), _vm.innerValue ? _c('div', {
    ref: "tooltip",
    staticClass: "guide__step-backdrop",
    style: _vm.stepBackdropStyle
  }, [_c('div', {
    ref: "guideControl",
    staticClass: "guide__tooltip",
    class: "guide__tooltip--" + _vm.innerConfig.tooltipAlign + " guide__tooltip--arrow-" + _vm.innerConfig.tooltipAlign,
    style: _vm.tooltipStyle
  }, [_vm.$scopedSlots[_vm.step + "Title"] ? _vm._t(_vm.step + "Title") : [_vm.currentStepData.title ? _c('div', {
    staticClass: "guide__title",
    class: _vm.innerConfig.titleClass,
    style: _vm.innerConfig.titleStyle
  }, [_vm._v("\n          " + _vm._s(_vm.currentStepData.title) + "\n        ")]) : _vm._e()], _vm._v(" "), _vm.$scopedSlots[_vm.step + "Message"] ? _vm._t(_vm.step + "Message") : [_vm.currentStepData.message ? _c('div', {
    staticClass: "guide__message",
    class: _vm.innerConfig.messageClass,
    style: _vm.innerConfig.messageStyle
  }, [_vm._v("\n          " + _vm._s(_vm.currentStepData.message) + "\n        ")]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "guide__buttons"
  }, [_vm.$scopedSlots.buttonSkip ? _vm._t("buttonSkip", null, {
    "skip": _vm.close
  }) : _c('div', {
    staticClass: "guide__skip-button",
    class: _vm.innerConfig.skipButtonClass,
    style: _vm.innerConfig.skipButtonStyle,
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          " + _vm._s(_vm.innerConfig.skipButtonText) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "guide__nav-buttons"
  }, [_vm.$scopedSlots.buttonPrev ? _vm._t("buttonPrev", null, {
    "prev": _vm.onPrevStep,
    "canPrev": _vm.canPrev
  }) : _c('button', {
    staticClass: "guide__nav-button",
    class: _vm.innerConfig.prevButtonClass,
    style: _vm.innerConfig.prevButtonStyle,
    attrs: {
      "disabled": !_vm.canPrev
    },
    on: {
      "click": _vm.onPrevStep
    }
  }, [_vm._v("\n            " + _vm._s(_vm.innerConfig.prevButtonText) + "\n          ")]), _vm._v(" "), _vm.$scopedSlots.buttonNext ? _vm._t("buttonNext", null, {
    "next": _vm.onNextStep,
    "canNext": _vm.canNext
  }) : _c('button', {
    staticClass: "guide__nav-button",
    class: _vm.innerConfig.nextButtonClass,
    style: _vm.innerConfig.nextButtonStyle,
    attrs: {
      "disabled": !_vm.canNext
    },
    on: {
      "click": _vm.onNextStep
    }
  }, [_vm._v("\n            " + _vm._s(_vm.innerConfig.nextButtonText) + "\n          ")])], 2)], 2)], 2)]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-01361f4e_0", {
    source: ".guide[data-v-01361f4e]{position:relative}.guide__backdrop[data-v-01361f4e]{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.5);z-index:9999}.guide__step-backdrop[data-v-01361f4e],.guide__tooltip[data-v-01361f4e]{z-index:999998;position:absolute}.guide__tooltip[data-v-01361f4e]{top:100%;margin-top:16px;background:#fff;border-radius:4px;padding:16px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px rgba(0,0,0,.14),0 1px 14px rgba(0,0,0,.12);max-width:300px;min-width:300px;border-color:#fff}.guide__tooltip[data-v-01361f4e]::before{content:'';display:block;position:absolute;width:0;height:0;top:-8px;border-bottom:8px solid #fff;border-left:8px solid transparent!important;border-right:8px solid transparent!important;border-top:none;border-color:inherit}.guide__tooltip--left[data-v-01361f4e]{left:0}.guide__tooltip--center[data-v-01361f4e]{transform:translateX(-50%);left:50%}.guide__tooltip--right[data-v-01361f4e]{right:0}.guide__tooltip--arrow-right[data-v-01361f4e]::before{right:20px}.guide__tooltip--arrow-left[data-v-01361f4e] ::before{left:20px}.guide__tooltip--arrow-center[data-v-01361f4e]::before{left:50%;transform:translateX(-50%)}.guide__step-backdrop[data-v-01361f4e]{display:block;background:#fff;position:absolute;z-index:99999;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px rgba(0,0,0,.14),0 1px 14px rgba(0,0,0,.12)}.guide__title[data-v-01361f4e]{font-weight:700;font-size:17px;line-height:21px;margin-bottom:8px}.guide__message[data-v-01361f4e]{font-size:14px;line-height:18px;margin-bottom:24px}.guide__buttons[data-v-01361f4e]{display:flex;justify-content:space-between;align-items:flex-end}.guide__nav-buttons[data-v-01361f4e]{display:flex;align-items:center}.guide__nav-button[data-v-01361f4e]{height:32px;outline:0;border-radius:4px;border:none;padding:0 16px;font-size:12px;cursor:pointer;background-color:#3eaf7c;color:#fff}.guide__nav-button[disabled][data-v-01361f4e]{cursor:default;opacity:.5}.guide__nav-button[data-v-01361f4e]:first-child{margin-right:8px}.guide__skip-button[data-v-01361f4e]{font-size:12px;line-height:18px;cursor:pointer;color:#b6b6b6}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-01361f4e";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installVueSiteGuide(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueSiteGuide', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
